import { State, Action } from './types'

function assertNever(state: State, _: never) {
  return state
}

export function reducer(state: State, action: Action) {
  switch (action.type) {
    case 'unsavedChanges': {
      return {
        ...state,
        unsavedChanges: action.payload,
      }
    }
    case 'submitRows': {
      return {
        ...state,
        unsavedChanges: false,
        submittingDataset: true,
      }
    }
    case 'toggleSubmittingDataset': {
      return {
        ...state,
        submittingDataset: !state.submittingDataset,
      }
    }
    case 'resetSubmittingDataset': {
      return {
        ...state,
        submittingDataset: false,
        submissionName: '',
      }
    }
    case 'setSubmissionName': {
      return {
        ...state,
        submissionName: action.payload,
      }
    }
    case 'setBlockSubmit': {
      return {
        ...state,
        blockSubmit: true,
      }
    }
    case 'setUnblockSubmit': {
      return {
        ...state,
        blockSubmit: Boolean(state.errors.length),
      }
    }
    case 'blockSubmit': {
      const { errors, errorCount, blockSubmit } = action.payload

      return {
        ...state,
        blockSubmit,
        errors,
        errorCount,
      }
    }
    case 'isSubmissionNameInFocus': {
      return {
        ...state,
        isSubmissionNameInFocus: true,
      }
    }
    case 'setSubmissionNameFocus': {
      return {
        ...state,
        isSubmissionNameInFocus: action.payload,
      }
    }
    case 'resetDataContainer': {
      return {
        ...state,
        loading: true,
        dataContainer: {},
      }
    }
    case 'setDataContainer': {
      return {
        ...state,
        loading: false,
        dataContainer: action.payload,
      }
    }
    case 'setPasteStatus': {
      return {
        ...state,
        isPasting: action.payload,
      }
    }
    case 'setHeaderTitleInvalid': {
      return {
        ...state,
        headerTitleInvalid: action.payload,
      }
    }
    default:
      return assertNever(state, action)
  }
}

export const initialState = {
  unsavedChanges: false,
  submittingDataset: false,
  errors: [],
  errorCount: 0,
  blockSubmit: false,
  headerTitleInvalid: false,
  submissionName: '',
  loading: true,
  dataContainer: {},
  isPasting: false,
  isSubmissionNameInFocus: false,
}
